import './executivesearch.css'
import { useState, useEffect } from 'react';
import { 
  FaChessKing, 
  FaMoneyBillWave, 
  FaFlask, 
  FaShoppingCart, 
  FaUsers, 
  FaIndustry, 
  FaChartLine, 
  FaLightbulb 
} from 'react-icons/fa';

export default function ExecutiveSearch() {
     const [mobileVersion, setMobileVersion] = useState(window.innerWidth <= 767);
        useEffect(() => {
            function handleResize() {
                setMobileVersion(window.innerWidth <= 767);
            }
    
            window.addEventListener('resize', handleResize);
    
            return () => {
                window.removeEventListener('resize', handleResize);
            }
        }, []);
    const companies = [
        "Adecco Group", "Air Liquide", "Anvis Group", "Audi", "AVL Schrick",
        "Benteler International", "Bethmann Bank", "BP Europa SE", "Caldic", "Coresystems (SAP)",
        "CTS Eventim", "Deutsche Bahn", "XALT Energy", "E.ON", "Airbus",
        "EnBW", "Evonik Industries", "Faurecia", "Magna International", "Köppern Maschinenfabrik",
        "LenioBio", "Logicalis", "MBtech Group", "Nidec Corporation", "Plastic Omnium",
        "Porsche", "Riedel Communications", "Roche Diagnostics", "Schenker", "SEAT",
        "Škoda", "Solaris Bus & Coach", "T-Systems International", "TMD Frictions", "TÜV Süd",
        "UFI Filters", "Veolia", "Vitrulan Textilglas", "Volkswagen"
    ];
    return (
        <div id='executive' className={mobileVersion ? 'mob-executive-container' : 'executive-container'}>
            <div id="executive-container" className="text-container">
                <h2>Executive Search</h2>
                <p>As a boutique executive search firm, we offer highly personalized support and focused
                    expertise to fill even the most demanding and challenging positions. With our long-standing experience and deep network, we are able to attract executives and specialists
                    for highly exclusive roles often beyond traditional channels.
                    <br />
                    <br />
                    Our approach combines in-depth market knowledge with a precise, discreet search
                    process to identify the ideal candidate who not only meets the technical requirements
                    but also fits your company culture.
                    <br />
                    <br />
                    Trust, discretion, and individual attention are always at the core of what we do.</p>



                <p style={{ fontWeight: 'bold' }}>Active Sourcing for Specialists</p>
                <p>
                    Active sourcing is a dynamic and strategic process through which we proactively
                    identify top talent. Using precise market analysis and advanced research methods, we
                    find candidates who possess the required qualifications - even if they are not actively
                    seeking new opportunities.
                    <br />
                    Our goal is to enhance your organization with the right professionals who create long-term value. We rely on a personal, tailored approach that not only engages talent but
                    also generates authentic interest in your company and its culture.
                </p>
            </div>
                <div id={mobileVersion ? 'mob-functions' : 'functions'}>
                    <h2>OUR EXPERTISE</h2>
                    <div className="section-divider" />
                    <div className="functions-container">
                        <div className="function-grid">
                            <div className="function-card">
                                <div className="card-content">
                                    <div className="icon-container"><FaChessKing /></div>
                                    <h3>Board and C-Level</h3>
                                    <p>Strategic leadership and executive decision-making support</p>
                                </div>
                            </div>
                            <div className="function-card">
                                <div className="card-content">
                                    <div className="icon-container"><FaMoneyBillWave /></div>
                                    <h3>Finance</h3>
                                    <p>Financial strategy, planning, and optimization</p>
                                </div>
                            </div>
                            <div className="function-card">
                                <div className="card-content">
                                    <div className="icon-container"><FaFlask /></div>
                                    <h3>R&D</h3>
                                    <p>Innovation management and research development</p>
                                </div>
                            </div>
                            <div className="function-card">
                                <div className="card-content">
                                    <div className="icon-container"><FaShoppingCart /></div>
                                    <h3>Procurement</h3>
                                    <p>Strategic sourcing and supply chain optimization</p>
                                </div>
                            </div>
                            <div className="function-card">
                                <div className="card-content">
                                    <div className="icon-container"><FaUsers /></div>
                                    <h3>Human Resources</h3>
                                    <p>Talent management and organizational development</p>
                                </div>
                            </div>
                            <div className="function-card">
                                <div className="card-content">
                                    <div className="icon-container"><FaIndustry /></div>
                                    <h3>Manufacturing</h3>
                                    <p>Operational excellence and production optimization</p>
                                </div>
                            </div>
                            <div className="function-card">
                                <div className="card-content">
                                    <div className="icon-container"><FaChartLine /></div>
                                    <h3>Sales & Operations</h3>
                                    <p>Revenue growth and operational efficiency</p>
                                </div>
                            </div>
                            <div className="function-card">
                                <div className="card-content">
                                    <div className="icon-container"><FaLightbulb /></div>
                                    <h3>Other Functions</h3>
                                    <p>Customized solutions for unique challenges</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
       <div id="customers" className="customers-section">
  <div className="customers-inner">
    <h2>Our Customers</h2>
    <div className="section-divider"></div>
    <p className="customers-subtitle">reflecting our impact</p>
    
    <div className="customer-display">
      {companies.map((company, index) => (
        <div key={index} className="company-name">
          <span className="company-name-text">{company}</span>
        
        </div>
      ))}
    </div>
  </div>
</div>
            <div id="focus">
                <p>COUNTRY AND INDUSTRY FOCUS</p>
                <hr/>
                <p>CAE COMPANY has built its reputation through successful projects in 17 countries and across more than 15 industries. Our commitment extends across the Americas, Central and Eastern  Europe, and Asia, grounded in our extensive experience across diverse domains. Whether it's industry or pharma, banking or FMCG, energy or logistics – a key factor for mutual success is a collaborative partnership based on trust and equality.</p>
            </div>

        </div>
    );
}